import { useEnvironmentInterface } from "environment-interface";

import { useAnalytics } from "hooks/useAnalytics";

import type { Command } from "../../types";

export const useOpenKeyboardShortcutsCommand = (
  event_source: "main_menu",
): Command => {
  const { monacoEditor } = useEnvironmentInterface();
  const track = useAnalytics();

  return {
    id: "workbench.action.openGlobalKeybindings",
    name: "Keyboard Shortcuts",
    section: "Preferences",
    perform: async () => {
      track("open_keyboard_shortcuts", { event_source });
      const vscodeApi = await monacoEditor.getExtensionApi();
      vscodeApi.commands.executeCommand(
        "workbench.action.openGlobalKeybindings",
      );
    },
  };
};
